module.exports = __webpack_public_path__ + "img/213.04e34701.jpg";